// extracted by mini-css-extract-plugin
export var actionButton = "_kn-0";
export var fileInput = "_kn-2";
export var paperclip = "_kn-1";